import { Edge } from 'reactflow';

/**
 * Extracts handle identifiers from edges for a specific node
 * @param nodeId - ID of the node to get handles for
 * @param edges - Array of edges in the graph
 * @returns Array of handle identifiers
 */
export const getHandlesFromEdges = (
    nodeId: string,
    edges: Edge[],
): string[] => {
    const nodeEdges = edges.filter((edge) => edge.source === nodeId);

    // Extract handle identifiers from sourceHandle property
    const handles = nodeEdges.map((edge) => {
        if (edge.sourceHandle) {
            // Handle format is typically "nodeId_handleId"
            const handleParts = edge.sourceHandle.split('_');
            return handleParts[handleParts.length - 1];
        } else if (edge.id) {
            // Try to extract from edge ID as fallback
            const idParts = edge.id.split('_');
            return idParts[idParts.length - 1];
        }
        return '';
    });

    const sortedHandles = handles.sort(
        (a, b) => parseInt(a, 10) - parseInt(b, 10),
    );

    return sortedHandles && sortedHandles.length > 0 ? sortedHandles : ['0'];
};

/**
 * Sorts handle identifiers numerically
 * @param handles - Array of handle identifiers to sort
 * @returns Sorted array of handle identifiers
 */
export const sortHandles = (handles: string[]): string[] => {
    return handles.sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
};

export const handleStyles = {
    width: '9px',
    height: '9px',
    border: '1px solid #fff',
};
